import { createTheme } from './createTheme';
import { DARK_MODE, GRAY_SCALE } from 'constants/ThemeConstant';
import { rgba, mixOnBackground, createOpaqueTableRowColors, buildOpaqueTableRowScopedStyles, getTableRowTokens, getColoredHeaderTableTokens, buildThemeTableSorterScopedStyles, buildThemeCheckboxScopedStyles, buildThemeGroupRowCssVariables } from './utils';

const CULTURE_DAY_PRIMARY = '#822E01';
/** Nền workspace / header — peach kem nhạt (mockup dashboard) */
const CULTURE_DAY_BG = '#EFBFA4';
/** Sidebar custom-menu — nâu đất đậm */
const CULTURE_DAY_CUSTOM_MENU_BG = CULTURE_DAY_PRIMARY;
const CULTURE_DAY_TEXT = '#531D1D';
const CULTURE_DAY_BORDER = '#822E01';
/** Màu nền group-row table */
const CULTURE_DAY_GROUP = mixOnBackground(CULTURE_DAY_PRIMARY, 0.7, GRAY_SCALE.WHITE);
const CULTURE_DAY_MODULE_ICON = GRAY_SCALE.WHITE;
/** Icon menu / nhãn form khi active (selected) — tương phản trên nền tối */
const CULTURE_DAY_ACTIVE_ICON = CULTURE_DAY_PRIMARY;
/** Tiêu đề nhóm menu (NGHIỆP VỤ, TÀI LIỆU) — trắng trên nền sidebar nâu */
const CULTURE_DAY_MENU_GROUP_TITLE = GRAY_SCALE.WHITE;
const CULTURE_DAY_TABLE_ROW_COLORS = createOpaqueTableRowColors(CULTURE_DAY_PRIMARY, GRAY_SCALE.WHITE);
/** Sidebar custom-menu — không dùng token Menu global */
export const cultureDayCustomMenuStyles = `
.side-nav .custom-menu.ant-menu-dark,
.side-nav .custom-menu.ant-menu-dark .ant-menu-sub {
    background: ${CULTURE_DAY_CUSTOM_MENU_BG} !important;
}
.side-nav .custom-menu.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected),
.side-nav .custom-menu.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected) .ant-menu-title-content,
.side-nav .custom-menu.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected) .nav-item_title,
.side-nav .custom-menu.ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-selected) > .ant-menu-submenu-title,
.side-nav .custom-menu.ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-selected) > .ant-menu-submenu-title .nav-item_title,
.side-nav .custom-menu.ant-menu-dark .ant-menu-submenu .ant-menu-sub .ant-menu-item:not(.ant-menu-item-selected) {
    color: ${GRAY_SCALE.WHITE} !important;
}
.side-nav .custom-menu.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected) .anticon,
.side-nav .custom-menu.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected) .ant-menu-item-icon,
.side-nav .custom-menu.ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-selected) > .ant-menu-submenu-title .anticon,
.side-nav .custom-menu.ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-selected) > .ant-menu-submenu-title .ant-menu-item-icon {
    color: ${CULTURE_DAY_MODULE_ICON} !important;
    fill: ${CULTURE_DAY_MODULE_ICON} !important;
}
.side-nav .custom-menu .ant-menu-item-group-title,
.side-nav .custom-menu .ant-menu-item-group-title .nav-item_title {
    color: ${CULTURE_DAY_MENU_GROUP_TITLE} !important;
}
.custom-menu-popup.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected),
.custom-menu-popup.ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open):not(.ant-menu-submenu-active) > .ant-menu-submenu-title {
    color: ${GRAY_SCALE.WHITE} !important;
}
.custom-menu-popup.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected) .anticon,
.custom-menu-popup.ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open) > .ant-menu-submenu-title .anticon {
    color: ${CULTURE_DAY_MODULE_ICON} !important;
}
.side-nav .custom-menu .ant-menu-item.ant-menu-item-selected .anticon,
.side-nav .custom-menu .ant-menu-item.ant-menu-item-selected .ant-menu-item-icon,
.side-nav .custom-menu .ant-menu-item.ant-menu-item-selected .anticon svg,
.side-nav .custom-menu .ant-menu-submenu.ant-menu-submenu-selected > .ant-menu-submenu-title .anticon,
.side-nav .custom-menu .ant-menu-submenu.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-item-icon,
.custom-menu-popup.ant-menu-dark .ant-menu-item.ant-menu-item-selected .anticon,
.custom-menu-popup.ant-menu-dark .ant-menu-submenu.ant-menu-submenu-selected > .ant-menu-submenu-title .anticon {
    color: ${CULTURE_DAY_ACTIVE_ICON} !important;
    fill: ${CULTURE_DAY_ACTIVE_ICON} !important;
}
`;

/** Steps điều hướng form (className="step-nav") */
export const cultureDayStepNavStyles = `
.step-nav.ant-steps .ant-steps-item-title {
    color: ${CULTURE_DAY_TEXT} !important;
    font-size: 13px !important;
}
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-title,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-title {
    color: ${CULTURE_DAY_PRIMARY} !important;
    font-weight: 600 !important;
}
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon {
    background-color: transparent !important;
    border-color: ${CULTURE_DAY_PRIMARY} !important;
}
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon .anticon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon .anticon {
    color: ${CULTURE_DAY_PRIMARY} !important;
}
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon {
    background-color: transparent !important;
    border-color: ${CULTURE_DAY_BORDER} !important;
}
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon .anticon {
    color: ${GRAY_SCALE.GRAY} !important;
}
`;

export const cultureDayScopedStyles = `
${cultureDayCustomMenuStyles}
${cultureDayStepNavStyles}
.ant-table-wrapper .ant-table-thead > tr > th {
    font-weight: 600;
    text-transform: uppercase;
}
${buildThemeTableSorterScopedStyles(CULTURE_DAY_PRIMARY)}
${buildOpaqueTableRowScopedStyles(CULTURE_DAY_TABLE_ROW_COLORS)}
${buildThemeCheckboxScopedStyles('light')}
${buildThemeGroupRowCssVariables(CULTURE_DAY_PRIMARY, CULTURE_DAY_GROUP, 'light', CULTURE_DAY_BG)}
`;

export const cultureDayTheme = createTheme({
    primaryColor: CULTURE_DAY_PRIMARY,
    successColor: '#FF85C0',
    warningColor: '#FFC0CB',
    errorColor: '#FF4D4F',
    bgColor: CULTURE_DAY_BG,
    textColor: CULTURE_DAY_TEXT,
    borderColor: CULTURE_DAY_BORDER,
    bodyBg: CULTURE_DAY_BG,
    colorBgLayout: CULTURE_DAY_BG,
    menuGroupTitleColor: CULTURE_DAY_MENU_GROUP_TITLE,
    moduleMenuBg: CULTURE_DAY_PRIMARY,
    moduleMenuIconColor: CULTURE_DAY_MODULE_ICON,
    moduleMenuItemColor: GRAY_SCALE.WHITE,
    moduleMenuItemSelectedBg: GRAY_SCALE.WHITE,
    moduleMenuItemSelectedColor: CULTURE_DAY_PRIMARY,
    moduleMenuItemSelectedBorderColor: CULTURE_DAY_PRIMARY,
    headerNavColor: CULTURE_DAY_BG,
    headerNavBorderColor: CULTURE_DAY_PRIMARY,
    siderBg: CULTURE_DAY_CUSTOM_MENU_BG,
    customMenuBg: CULTURE_DAY_CUSTOM_MENU_BG,
    customMenuAntTheme: 'dark',
    customMenuItemSelectedColor: CULTURE_DAY_PRIMARY,
    customMenuItemSelectedBg: GRAY_SCALE.WHITE,
    customMenuItemSelectedIconColor: CULTURE_DAY_ACTIVE_ICON,
    customMenuItemSelectedBorderColor: GRAY_SCALE.WHITE,

    footerBg: CULTURE_DAY_PRIMARY,
    footerTextColor: GRAY_SCALE.WHITE,

    componentOverrides: {
        Layout: {
            bodyBg: CULTURE_DAY_BG,
            headerBg: CULTURE_DAY_BG,
            siderBg: CULTURE_DAY_CUSTOM_MENU_BG,
        },
        Menu: {
            darkItemBg: 'transparent',
            darkItemColor: GRAY_SCALE.WHITE,
            darkItemSelectedBg: GRAY_SCALE.WHITE,
            darkItemSelectedColor: CULTURE_DAY_PRIMARY,
            darkItemHoverBg: rgba(GRAY_SCALE.WHITE, 0.08),
            darkItemHoverColor: GRAY_SCALE.WHITE,
            darkSubMenuItemBg: CULTURE_DAY_CUSTOM_MENU_BG,
            popupBg: CULTURE_DAY_CUSTOM_MENU_BG,
            activeBarWidth: 0,
            boxShadowSecondary: DARK_MODE.DROP_DOWN_SHADOW,
        },
        Breadcrumb: {
            itemColor: GRAY_SCALE.GRAY,
            lastItemColor: CULTURE_DAY_PRIMARY,
            linkColor: GRAY_SCALE.GRAY,
            linkHoverColor: CULTURE_DAY_PRIMARY,
            separatorColor: GRAY_SCALE.GRAY,
        },
        Card: {
            colorBgContainer: GRAY_SCALE.WHITE,
            colorTextHeading: CULTURE_DAY_PRIMARY,
            colorText: CULTURE_DAY_TEXT,
            colorBorderSecondary: CULTURE_DAY_BORDER,
            extraColor: CULTURE_DAY_TEXT,
            headerBg: GRAY_SCALE.WHITE,
            actionsBg: GRAY_SCALE.WHITE,
            borderRadiusLG: 22,
        },
        Table: {
            colorText: CULTURE_DAY_TEXT,
            colorTextHeading: GRAY_SCALE.WHITE,
            headerBg: CULTURE_DAY_PRIMARY,
            borderColor: '#F0F0F0',
            ...getColoredHeaderTableTokens(CULTURE_DAY_PRIMARY),
            ...getTableRowTokens(CULTURE_DAY_TABLE_ROW_COLORS),
        },
        Steps: {
            colorPrimary: CULTURE_DAY_PRIMARY,
            colorText: CULTURE_DAY_TEXT,
            colorTextDescription: GRAY_SCALE.GRAY,
        },
        Input: {
            colorBgContainer: GRAY_SCALE.WHITE,
            colorBorder: CULTURE_DAY_BORDER,
            activeBorderColor: CULTURE_DAY_PRIMARY,
            hoverBorderColor: CULTURE_DAY_PRIMARY,
        },
        DatePicker: {
            colorBgContainer: GRAY_SCALE.WHITE,
            colorBorder: CULTURE_DAY_BORDER,
            activeBorderColor: CULTURE_DAY_PRIMARY,
            hoverBorderColor: CULTURE_DAY_PRIMARY,
        },
        Button: {
            defaultBg: GRAY_SCALE.WHITE,
            defaultHoverBg: GRAY_SCALE.WHITE,
            defaultActiveBg: GRAY_SCALE.WHITE,
            defaultBorderColor: CULTURE_DAY_BORDER,
            defaultHoverBorderColor: CULTURE_DAY_PRIMARY,
            defaultActiveBorderColor: CULTURE_DAY_PRIMARY,
        },
        Dropdown: {
            colorBgElevated: GRAY_SCALE.WHITE,
            colorText: CULTURE_DAY_TEXT,
            colorPrimary: CULTURE_DAY_PRIMARY,
            controlItemBgHover: rgba(CULTURE_DAY_PRIMARY, 0.06),
            controlItemBgActive: rgba(CULTURE_DAY_PRIMARY, 0.1),
            controlItemBgActiveHover: rgba(CULTURE_DAY_PRIMARY, 0.14),
        },
        Select: {
            colorBgContainer: GRAY_SCALE.WHITE,
            selectorBg: GRAY_SCALE.WHITE,
            colorBgElevated: GRAY_SCALE.WHITE,
            optionSelectedBg: rgba(CULTURE_DAY_PRIMARY, 0.1),
            optionActiveBg: rgba(CULTURE_DAY_PRIMARY, 0.06),
            colorBorder: CULTURE_DAY_BORDER,
            activeBorderColor: CULTURE_DAY_PRIMARY,
            hoverBorderColor: CULTURE_DAY_PRIMARY,
        },
    },
});
